import { render } from "./UserCardsFlat.vue?vue&type=template&id=78854808&scoped=true"
import script from "./UserCardsFlat.vue?vue&type=script&lang=js"
export * from "./UserCardsFlat.vue?vue&type=script&lang=js"

import "./UserCardsFlat.vue?vue&type=style&index=0&id=78854808&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78854808"]])

export default __exports__